import { Field } from 'redux-form';
import { TextField } from 'iqvia-shared/components';
import React from 'react';

const TextObjectField = ({ name, label, onChange, readonlyForm }) => (
  <Field
    name={`${name}`}
    component={TextField}
    label={label}
    disabled={readonlyForm}
    onChange={(_, value) => onChange(value)}
  />
);

TextObjectField.displayName = 'TextObjectField';

export default TextObjectField;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathObjectFields/TextObjectField.js